import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { useSubscriptionContext } from '~/providers/SubscriptionProvider';

export const useIsCreativePerformanceEnabled = () => {
  const { performanceAnalytics } = useTemporaryFeatureFlags();

  const { data: subscription } = useSubscriptionContext();

  return {
    isEnabled: !!performanceAnalytics || !!subscription?.isEnterprise,
  };
};
